import React from 'react';
import Icon from '../../components/Icon';
import {
  $Container,
  $Label,
  $Message,
  $CloseButton,
} from './ProTipToast.styled';

interface Props {
  onDismiss: () => void;
  onClick?: () => void;
  label?: string;
  message?: string;
}

const ProTipToast: React.FC<Props> = ({ 
  onDismiss, 
  onClick, 
  label = "PRO TIP",
  message = "Automate account verification with the API" 
}) => {
  return (
    <$Container data-cy="pro-tip-toast">
      <$Label>{label}</$Label>
      <$Message onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
        {message}
      </$Message>
      <$CloseButton onClick={onDismiss} data-cy="pro-tip-close">
        <Icon name="Close" size={16} />
      </$CloseButton>
    </$Container>
  );
};

export default ProTipToast;
